import { createContext } from 'react';
// === Provide a context all math views can read ===
export const AllowedKeysContext = createContext<string[] | null>(null);
